import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';
import offlineRfsRemote from '../../../api/offlineRfsRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import { OrderLockStatusType } from '../../../models/OrderLockStatusType.enum';
import OrderWhsDetails from '../../../models/OrderWhsDetails';
import WhsOrderNote from './WhsOrderNote';

interface WhsOrderNoteContainerProps {
  type: string;
  history: { push: Function; };
  match: { isExact: boolean; params: { awbCode: string; awbNumber: string; number: string }; path: string; url: string; };
  location: any;
  receiveError: Function;
};
  
interface WhsOrderNoteContainerState {
  note: { note: string };
  attachments: string[];
  onlyRead: boolean;
  order: { 
    lock_status: string,
    gha_wh_user_name: string
  }
};

class WhsOrderNoteContainer extends Component<WhsOrderNoteContainerProps, WhsOrderNoteContainerState> {

  state = {
    note: {
      note: ''
    },
    attachments: [],
    onlyRead: false,
    order: {
      lock_status: '',
      gha_wh_user_name: '',
      driver_signature_key: '',
      rfs_number: ''
    }
  }
  
  componentDidMount() {

    const number: string = this.props.match.params.number;
    if(this.props.location.state) {
      const onlyRead = this.props.location.state.onlyRead;
      this.setState({ onlyRead })
     
    }

    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      pickupOrderRemote.getGhaPoNote(number).then((resp: ApiResponse<{ note: string, attachments: string[] }>) => {

        const noteResp: { note: string, attachments: string[] } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (noteResp) {
          this.setState({ note: {note: noteResp.note}, attachments: noteResp.attachments });

          pickupOrderRemote.getPickupOrderWhs(number).then((resp: ApiResponse<OrderWhsDetails>) => {

            const order: OrderWhsDetails | undefined = resp.result;
            const error: ResponseError | undefined = resp.error;
      
            if (order) {
              
              this.setState({ order });
      
              if(!this.state.order.driver_signature_key) {
                this.doLockPickupOrder();
              }
            }
      
            if (error) {
              this.props.receiveError(error);
            };
          });
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.getGhaPoNote(number).then((resp: ApiResponse<{ note: string, attachments: string[] }>) => {

        const noteResp: { note: string, attachments: string[] } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (noteResp) {
          this.setState({ note: {note: noteResp.note}, attachments: noteResp.attachments });

          offlineRfsRemote.getOfflineOrderWhs(number).then((resp: ApiResponse<OrderWhsDetails>) => {

            const order: OrderWhsDetails | undefined = resp.result;
            const error: ResponseError | undefined = resp.error;
      
            if (order) {
              
              this.setState({ order });
      
              if(!this.state.order.driver_signature_key) {
                this.doLockPickupOrder();
              }
            }
      
            if (error) {
              this.props.receiveError(error);
            };
          });
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  componentWillUnmount() {

    if(!this.state.order.driver_signature_key) {
      this.doLockPickupOrder();
    }
  }

  doLockPickupOrder = (): void => {

    const locked: boolean = this.state.order.lock_status === OrderLockStatusType.UNLOCKED;
    const number: string = this.props.match.params.number;

    if((this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') && number) {

      pickupOrderRemote.doGhaWhPoLock(number, locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          const order = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }

    if(this.props.type === 'rfs') {

      offlineRfsRemote.doGhaWhPoLock(parseInt(number), locked).then((resp: ApiResponse<{ lock_status: string; gha_wh_user_name: string; }>) => {

        const updateValues: { lock_status: string; gha_wh_user_name: string; } | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (updateValues) {
          const order = { ...this.state.order };

          order.lock_status = updateValues.lock_status;
          order.gha_wh_user_name = updateValues.gha_wh_user_name;

          this.setState({ order });
        }
    
        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

    this.setState({ note: { note: event.target.value } });
  }

  saveExit = (type: string): void => {

    const number: string = this.props.match.params.number;

    if (type === 'save') {

      if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

        pickupOrderRemote.updateGhaPoNote(number, this.state.note).then((resp: ApiResponse<boolean>) => {

          const updated: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;

          if (updated) {
            this.props.history.push(`/whs/${this.props.type}/${number}`);
          }
    
          if (error) {
            this.props.receiveError(error);
          };
        });
      }

      if(this.props.type === 'rfs') {

        offlineRfsRemote.updateGhaPoNote(number, this.state.note).then((resp: ApiResponse<boolean>) => {

          const updated: boolean | undefined = resp.success;
          const error: ResponseError | undefined = resp.error;

          if (updated) {
            this.props.history.push(`/whs/${this.props.type}/${number}`);
          }
    
          if (error) {
            this.props.receiveError(error);
          };
        });
      }
      
    } else {
      this.props.history.push(`/whs/${this.props.type}/${number}`);
    }
  }

  returnToDriver = () => {

    const orderNumber: string = this.props.match.params.number;
    if (this.props.type === 'do') {
      this.props.history.push(`/whs/do/return-drv-signature/${orderNumber}`);
    } else {
      throw new Error('Incorrect type of order.');
    }
  }

  handleAttachmentUpload = (event: any) => {
    if(event.target.files[0]) {
      const formData: FormData = new FormData();
      formData.append('attachment', event.target.files[0]);
  
      if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

        pickupOrderRemote.uploadGhaPoWhExceptionsAttachments(this.props.match.params.number, formData).then((resp) => {
          const attachments: string[] | undefined = resp.result;
          const error: ResponseError | undefined = resp.error;
          
          if (attachments) {
            this.setState({attachments});
          }
    
          if (error) {
            this.props.receiveError(error);
          };
        });
      }
    }
  }

  handleAttachmentDelete = (attachmentKey: string) => {
    
    if(this.props.type === 'po' || this.props.type === 'do' || this.props.type === 'go') {

      pickupOrderRemote.deleteGhaPoWhExceptionsAttachment(attachmentKey).then((resp) => {
        const attachments: string[] | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
        
        if (attachments) {
          this.setState({attachments});
        }

        if (error) {
          this.props.receiveError(error);
        };
      });
    }
  }

  render() {

    return (
      
      <>
        <WhsOrderNote
          note={ this.state.note.note }
          orderNumber={ this.props.type === "rfs" && this.state.order.rfs_number ? this.state.order.rfs_number : this.props.match.params.number }
          handleChange={ this.handleChange }
          returnToDriver={ this.returnToDriver }
          handleAttachmentDelete={ this.handleAttachmentDelete }
          handleAttachmentUpload={ this.handleAttachmentUpload }
          attachments={ this.state.attachments }
          saveExit={ this.saveExit }
          type={ this.props.type }
          onlyRead={ this.state.onlyRead }
        />
      </>
    )
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};
  
export default connect(null, mapDispatchToProps)(WhsOrderNoteContainer);
